import { gql } from '@apollo/client'

const FETCH_CANCELLATION_METRICS = gql`
  query FetchCancellationMetrics($fromDate: Date, $toDate: Date, $selectedStoreId: String) {
    fetchCancellationMetrics(
      fromDate: $fromDate
      toDate: $toDate
      selectedStoreId: $selectedStoreId
    ) {
      allStoreOrdersCount
      cancelledStoreOrdersCount
      cancelledStoreOrdersPercent
      cancelledStoreOrderEventsGroupCount {
        id
        count
        percent
      }
      cancelledStoreOrderEventsOtherReason {
        details
        storeOrderId
      }
    }
  }
`

const FETCH_CANCELLATION_METRICS_CHART_DATA = gql`
  query FetchCancellationMetricsChartData(
    $fromDate: Date
    $toDate: Date
    $selectedStoreId: String
    $periodDays: Int
  ) {
    fetchCancellationMetricsChartData(
      fromDate: $fromDate
      toDate: $toDate
      selectedStoreId: $selectedStoreId
      periodDays: $periodDays
    ) {
      chartData {
        from
        to
        cancellationMetrics {
          allStoreOrdersCount
          cancelledStoreOrdersCount
          cancelledStoreOrdersPercent
          cancelledStoreOrderEventsGroupCount {
            id
            count
            percent
          }
          cancelledStoreOrderEventsOtherReason {
            details
            storeOrderId
          }
        }
      }
    }
  }
`

const FETCH_GEARFLOW_SHIPPING_METRICS = gql`
  query FetchGearflowShippingMetrics($fromDate: Date, $toDate: Date, $selectedStoreId: String) {
    fetchGearflowShippingMetrics(
      fromDate: $fromDate
      toDate: $toDate
      selectedStoreId: $selectedStoreId
    ) {
      netShippingAmount {
        amount
        currency
      }
      averageNetShippingAmount {
        amount
        currency
      }
      storeOrders {
        storeOrderId
        storeName
        storeOrderShippingCost {
          amount
          currency
        }
        labelCost {
          amount
          currency
        }
      }
      storeOrdersCount
      shippingPerStoreGroups {
        storeName
        netShippingAmount {
          amount
          currency
        }
        averageNetShippingAmount {
          amount
          currency
        }
        storeOrdersCount
      }
    }
  }
`

export {
  FETCH_CANCELLATION_METRICS,
  FETCH_CANCELLATION_METRICS_CHART_DATA,
  FETCH_GEARFLOW_SHIPPING_METRICS,
}
